import { render, staticRenderFns } from "./RatioCell.vue?vue&type=template&id=58393dd8"
import script from "./RatioCell.vue?vue&type=script&lang=js"
export * from "./RatioCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports